export default __webpack_public_path__ + "static/media/CheckPoint.01e977a1.svg";